import PasswordReset from '@/components/_templates/user/PasswordReset.vue';
import UserProfile from '@/components/_templates/user/Profile.vue';
import UserProfileGeneral from '@/components/_templates/user/profile/General.vue';
import UserNotification from '@/components/_templates/user/Notification.vue';

const userRoutes = [
  {
    path: '/user/profile',
    name: 'user.profile',
    component: UserProfile,
    meta: { requiresAuth: true },
    redirect: { name: 'user.profile.general' },
    children: [
      { path: 'general', name: 'user.profile.general', component: UserProfileGeneral },
    ],
  },
  {
    path: '/user/notification', name: 'user.notification', component: UserNotification,
  },
  /** Auth /**
   *
   */
  {
    path: '/password/reset/:token/:email', name: 'password.reset', component: PasswordReset, props: true,
  },
];

export default userRoutes;
